import { FC, useMemo } from 'react';
import { EasTable } from 'ui/EasTable';
import { splitItemTableStructure } from './tableStructure';
import { SplitItemTableProps, TSplitItemTableRow } from './types';

export const SplitItemTable: FC<SplitItemTableProps> = ({ items, loading, currency }) => {
	const itemsWithCurrency: TSplitItemTableRow[] = useMemo(
		() =>
			items.map((item) => ({
				...item,
				payment_currency_code: currency,
			})),
		[items, currency],
	);

	const handleAction = () => {};

	return (
		<EasTable<TSplitItemTableRow>
			tableStructure={splitItemTableStructure}
			items={itemsWithCurrency}
			itemsIsLoading={loading}
			handleAction={handleAction}
		/>
	);
};
